import { z } from 'zod';

export const CreatePaypalTokenResponseSchema = z.object({
  redirectURL: z.string(),
  token: z.string(),
});

export const CreatePaypalAgreementResponseSchema = z.object({
  agreement_id: z.string(),
  email_address: z.string().nullable(),
  token: z.string(),
});

// TypeScript Interfaces
export type PaypalTokenResponse = z.infer<typeof CreatePaypalTokenResponseSchema>;

export type PaypalAgreementResponse = z.infer<typeof CreatePaypalAgreementResponseSchema>;
